import { dataEnvelope } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnvelope = /*#__PURE__*/createIcon(dataEnvelope)
export default IconEnvelope
